import { gql } from "@apollo/client";

export const GetEncodeInvoiceUrl = gql`
query GetInvoiceSignedUrl($input: invoice_signed_url_input!) {
    url: invoice_signed_url(input: $input)
}
`